import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Select, Card, Row, Col, DatePicker, InputNumber, Table, Tooltip, Divider } from 'antd';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { Link, useHistory } from 'react-router-dom';
import './indent-form.css';
import moment from 'moment';
import { EmployeeRolesEnum, FarmTypesEnum, GlobalStatus, PlantsEnum, SupplierTypeEnum,RMInwardTypeEnum,  VehicleTypeEnum, QualityTypeEnum, PackageTypeEnum } from '@gtpl/shared-models/common-models';
import { CommissionType, CompanyCategoryEnum, HarvestingTime, IndentDetailsModel, IndentItemsModel, IndentModel, IndentRequest, RmCountReq, RmRatesInfoReq } from '@gtpl/shared-models/raw-material-procurement';
import { EmployeeDto, EmployeeRoleRequest, FarmTypeEnum, FarmerModel, FarmersDropDownDto, PlantsDropDown, ProductDto, SupplierTypeRequest } from '@gtpl/shared-models/masters';
import { ProductService, SuppliersService, EmployeeService, UnitcodeService } from '@gtpl/shared-services/masters';
import { IndentService, RmCountPriceListService } from '@gtpl/shared-services/raw-material-procurement';
import { EditOutlined, MinusCircleOutlined } from '@ant-design/icons';
import { HrmsEmpDetService } from '@gtpl/shared-services/masters';
import { Excel } from "antd-table-saveas-excel";
import * as XLSX from "xlsx";
import ExcelJS from 'exceljs';
const { Option } = Select;
/* eslint-disable-next-line */
export interface IndentFormProps {
  indentData: any,
  isUpdate: boolean,
  // form:any,
  closeDrawer: () => void,
  // updateIndent: (indent: IndentDetailsModel) => void
}

export function IndentForm(
  props: IndentFormProps
) {
  // const { getFieldDecorator } = props.form;

  const userName = localStorage.getItem("createdUser");
  const plantId = localStorage.getItem("unit_id");
  const [form] = Form.useForm();
  const [products, setProducts] = useState<ProductDto[]>([]);
  const [type, setType] = useState<string>('');
  const [brokers, setBrokers] = useState<FarmersDropDownDto[]>([]);
  const [farmers, setFarmers] = useState<FarmersDropDownDto[]>([]);
  const [farmerCodes, setFarmerCodes] = useState<FarmersDropDownDto[]>([]);
  const [employees, setEmployees] = useState<EmployeeDto[]>([]);
  const [indentEmployees, setIndentEmployees] = useState<any[]>([]);
  const [factoriesData, setFactoriesData] = useState<PlantsDropDown[]>([]);
  const [indentItemsData, setindentItemsData] = useState<IndentItemsModel[]>([]);
  const [tableData, setTableData] = useState<any[]>([]);
  const [fieldsData, setFieldsData] = useState<any>({});
  const [showTable, setShowTable] = useState<boolean>(false);
  const [commissionTypeHiddenState, setCommissionTypeHiddenState] = useState<boolean>(true);
  const [submitBtnDisable, setSubmitBtnDisable] = useState<boolean>(true);
  const [btnChange, setBtnChange] = useState<boolean>(false);
  const [indexVal, setIndexVal] = useState(0);
  const productService = new ProductService();
  const supplierService = new SuppliersService();
  const employeeService = new EmployeeService();
  const indentService = new IndentService();
  const empService = new HrmsEmpDetService();
  const [assignlead1, setAssignLead1] = useState(0);
  const [assignlead2, setAssignLead2] = useState(0);
  const [isFixed, setIsFixed] = useState(false);
  const [isHarvest, setIsHarvest] = useState(false);
  const [file, setFile] = useState<any>(null);
  const [rmType, setRmType] = useState<any>();
  const rmCountPriceListService = new RmCountPriceListService()
  const isEditMode = props.isUpdate;
  let history = useHistory();
  const unitcodeService = new UnitcodeService();
  const username = localStorage.getItem('username')

  console.log(username)
  let createdUser = '';
  if (!props.isUpdate) {
    createdUser = localStorage.getItem('createdUser');
  }

  const [vehicleRequired,setVehicleRequired] = useState<boolean>(false)

  useEffect(() => {
  getAllProducts();
  getAllMainPlants();
  getAllEmployesForProcManager();
  getAllIndentEmployees();

  if (!props.indentData) {
    const defaultSupplier = SupplierTypeEnum.FARMER;

    form.setFieldsValue({
      supplierType: defaultSupplier,
      harvestType: 'Re Weighment'
    });

    supplierService
      .getFarmersBySupplierType(new SupplierTypeRequest(defaultSupplier))
      .then(res => {
        if (res.status) {
          setFarmers(res.data);   
        } else {
          setFarmers([]);
        }
      })
      .catch(() => setFarmers([]));
  }

}, []);
console.log(props.indentData,'indent data in form');
useEffect(() => {
  if (props.isUpdate && props.indentData) {
    form.setFieldsValue({
      indentDate: moment(props.indentData.indentDate),
      supplierType: props.indentData.supplierType,
      harvestType: props.indentData.harvestType,
      rmInwardType: props.indentData.rmInwardType,
      indentBy: props.indentData.indentBy,
      plantId: props.indentData.plantId,
      boeDate: props.indentData?.boeDate
      ? moment(props.indentData.boeDate)
      : null,
    boeNum: props.indentData?.boeNum
    });
  }
  if (props.isUpdate && props.indentData?.supplierType === 'Farmer') {
    supplierService
      .getFarmersBySupplierType(new SupplierTypeRequest(SupplierTypeEnum.FARMER))
      .then(res => {
        if (res.status) {
          setFarmers(res.data);
        }
      });
  }
}, [props.indentData]);

useEffect(() => {
  const value = form.getFieldValue('rmInwardType');
  setRmType(value);
}, []);

  useEffect(() => {
  if (props.isUpdate && props.indentData?.indentId) {
    getIndentItemsData();
  }
}, [props.indentData]);

  useEffect(() => {
    if (tableData) {
      console.log(tableData);
    }
  }, [tableData])

  // To format the date on loading the page
  if (props.indentData) {
    props.indentData.indentDate = moment(props.indentData.indentDate);
    props.indentData.harvestingDate = moment(props.indentData.harvestingDate);
    if (props.indentData.isVehicleRequired == false) {
      props.indentData.isVehicleRequired = 0
      props.indentData.vehicleType=0
    } else {
      props.indentData.isVehicleRequired = 1
       props.indentData.vehicleType=VehicleTypeEnum.OWN 

    }

  }

  const getIndentItemsData = () => {
    const indentReq = new IndentRequest();
    indentReq.indentId = props.indentData.indentId;
    indentService.getIndentDataById(indentReq).then((res) => {
      if (res.status) {
        console.log(res.data)
        setShowTable(true)
        const mappedData = res.data.map(item => {
          return {
            ...item,
            farmerName: item.farmerCode || item.farmerName || ''
          };
        });
        setTableData(mappedData)
      }
      else {
        if (res.intlCode) {
          setTableData([]);
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    })
  }

  const getAllMainPlants = () => {
    unitcodeService.getAllMainPlants().then((res) => {
      if (res.status) {
        setFactoriesData(res.data)
      }
      else {
        if (res.intlCode) {
          setFactoriesData([]);
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    })
  }

  const getAllProducts = () => {
    productService.getAllActiveProducts().then(res => {
      if (res.status) {
        setProducts(res.data);
      } else {
        if (res.intlCode) {
          setProducts([]);
          AlertMessages.getErrorMessage('No Data Found');
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
      setProducts([]);
    });
  }

  const getAllEmployesForProcManager = () => {
    empService.getAllActiveEmployees().then(res => {
      if (res.status) {
        setEmployees(res.data);
      } else {
        if (res.intlCode) {
          setEmployees([]);
          AlertMessages.getErrorMessage('No Employees Data Found');
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
      setEmployees([]);
    });
  }

  const brokerChange = (brokerId: number) => {
    if (brokerId) {
      supplierService.getSuppliersByBrokerId({ brokerId: brokerId }).then(res => {
        if (res.status) {
          setFarmers(res.data);
        } else {
          if (res.intlCode) {
            setFarmers([]);
            AlertMessages.getErrorMessage('No Data Found');
          }
          //  else {
          //   AlertMessages.getErrorMessage(res.internalMessage);
          // }
        }
      }).catch(err => {
        AlertMessages.getErrorMessage(err.message);
        setFarmers([]);
      });
      form.setFieldsValue({ broker: brokerId, farmer: null, farmerCode: null });
    } else {
      form.setFieldsValue({ farmer: null, farmerCode: null });
    }
  }

  const farmerChange = (farmerId: number) => {
    if (farmerId) {
      supplierService.getFarmCodesBySupplierId(new FarmerModel(farmerId)).then(res => {
        if (res.status) {
          console.log(res.data)
          setFarmerCodes(res.data);
        } else {
          if (res.intlCode) {
            setFarmerCodes([]);
            AlertMessages.getErrorMessage('No Data Found');
          } else {
            AlertMessages.getErrorMessage(res.internalMessage);
          }
        }
      }).catch(err => {
        AlertMessages.getErrorMessage(err.message);
        setFarmerCodes([]);
      });
      form.setFieldsValue({ farmer: farmerId, farmerCode: null });
    } else {
      form.setFieldsValue({ farmerCode: null });
    }
  }
  const farmerCodeChange = (farmerId: number) => {
    form.setFieldsValue({ farmerCode: farmerId });
  }

  const handleFileChange = (e: any) => {
  setFile(e.target.files[0]);
};




const handleImportSubmit = async () => {
  try {
    const values =await form.getFieldsValue();

    if (
      values.rmInwardType === RMInwardTypeEnum.IMPORT &&
      (!values.boeNum || !values.boeNum.toString().trim() || !values.boeDate)
    ) {
      AlertMessages.getErrorMessage(
        'BOE Number and BOE Date are mandatory for Import'
      );
      return;
    }

    if (!file) {
      AlertMessages.getErrorMessage("Please upload file");
      return;
    }

    const reader = new FileReader();

    reader.onload = async (e: any) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData: any[] = XLSX.utils.sheet_to_json(sheet);

      if (!jsonData || jsonData.length === 0) {
        AlertMessages.getErrorMessage("Excel has no data");
        return;
      }

      const parsedData = jsonData.map((row: any, index: number) => {
  const qualityRaw = row["Quality"]?.toLowerCase().trim();

  const matchedQuality = Object.values(QualityTypeEnum).find(
    (q) => q.toLowerCase() === qualityRaw
  );

  const pkgRaw = row["Package Type"]?.toLowerCase().trim();

  const matchedPackage = Object.values(PackageTypeEnum).find(
    (p) => p.toLowerCase() === pkgRaw
  );
const grossWeight = Number(row["Gross Weight"] || 0);
const tareWeight = Number(row["Tare Weight"] || 0);

  return {
    quality: matchedQuality, 
    grossWeight: grossWeight,
    quantity: grossWeight - tareWeight,
    tareWeight: tareWeight,
    packageType: matchedPackage,
    variant: row["Variant"],
    farmer: values.farmer?.value,
   
  };
})
      
for (let i = 0; i < parsedData.length; i++) {
  const element = parsedData[i];

  const productObj = products.find(
    (p) =>
      p.productName?.trim().toLowerCase() ===
      element.variant?.trim().toLowerCase()
  );

  if (!productObj) {
    AlertMessages.getErrorMessage(
      `Invalid Variant at row ${i + 1}: ${element.variant}`
    );
    return; 
  }
}
for (let i = 0; i < parsedData.length; i++) {
  if (!parsedData[i].quality) {
    AlertMessages.getErrorMessage(
      `Invalid Quality at row ${i + 1}: ${jsonData[i]["Quality"]}`
    );
    return;
  }
}

for (let i = 0; i < parsedData.length; i++) {
  if (!parsedData[i].packageType) {
    AlertMessages.getErrorMessage(
      `Invalid Package Type at row ${i + 1}: ${jsonData[i]["Package Type"]}`
    );
    return;
  }
}

for (let i = 0; i < parsedData.length; i++) {

  if (Number(parsedData[i].tareWeight) > Number(parsedData[i].grossWeight)) {
    AlertMessages.getErrorMessage(
      `Tare Weight cannot be greater than Gross Qty at row ${i + 1}`
    );
    return;
  }

  if (parsedData[i].quantity < 0) {
  AlertMessages.getErrorMessage(
    `Gross Weight must be greater than or equal to Tare Weight at row ${i + 1}`
  );
  return;
}
}
      const indentItems = parsedData.map((element: any) => {
        const productObj = products.find(
  (p) =>
    p.productName?.trim().toLowerCase() ===
    element.variant?.trim().toLowerCase()
);
        return new IndentItemsModel(
          undefined,
          values.plantId || localStorage.getItem("unit_id"),
          element.farmer,
          undefined,
          productObj?.productId,
          undefined,
          element.quantity,
          undefined,
          undefined, undefined, undefined, undefined,
          undefined,
          undefined,
          localStorage.getItem("createdUser"),
          undefined, undefined, undefined,
          undefined, undefined,
          undefined,
          undefined,
          element.quality,
          element.packageType,
          undefined,
          element.grossWeight,
          undefined,
undefined,   
undefined,
element.tareWeight,
        );
      });

    const payload = new IndentDetailsModel(
  values.plantId || Number(localStorage.getItem("unit_id")), 
  values.indentDate,                                         
  values.supplierType,                                       

  undefined, 
  undefined, 
  undefined, // harvestingDate
  undefined, // harvestingTime
  undefined, // assignLead1
  undefined, // assignLead2

  indentItems, 

  values.indentBy, // indentBy
  localStorage.getItem("createdUser"), // ✅ createdUser

  undefined, // updatedUser
  undefined, // indentId
  undefined, // indentCode
  undefined, // vehicleAssigned
  undefined, // grnCompleted
  undefined, // createdAt
  undefined, // updatedAt
  undefined, // isActive
  undefined, // versionFlag
  undefined, // isVehicleRequired

  values.harvestType,        
  undefined,                 
  values.rmInwardType ,
  values.boeNum,
  values.boeDate       
);

      console.log("FINAL PAYLOAD:", payload);

      const res = await indentService.createIndent(payload);
console.log("API RESPONSE:", res);
      if (res.status) {
  AlertMessages.getSuccessMessage("Import Created Successfully");

  setTimeout(() => {
    history.push("/indent-view");
  }, 1000); 
}else {
        AlertMessages.getErrorMessage(res.internalMessage);
      }
    };

    reader.readAsArrayBuffer(file);

  } catch (error: any) {
    AlertMessages.getErrorMessage(error.message);
  }
};

const importSampleColumns = [
  { title: "Cartons No", dataIndex: "sNo" },
  { title: "Variant", dataIndex: "variant" },
  { title: "Quality", dataIndex: "quality" },
  { title: "Gross Weight", dataIndex: "grossWeight" },
   { title: "Tare Weight", dataIndex: "tareWeight" },
  { title: "Package Type", dataIndex: "packageType" }
];

const downloadSample = async () => {
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("RM Inward Import Format");

  const headerRow = sheet.addRow([
    "Cartons No",
    "Variant",
    "Quality",
    "Gross Weight",
    "Tare Weight",
    "Package Type"
  ]);

  headerRow.eachCell((cell) => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF00B050" }
    };
    cell.font = {
      bold: true,
      color: { argb: "FFFFFFFF" } 
    };
    cell.alignment = { vertical: "middle", horizontal: "center" };
  });

  const qualityValues = Object.values(QualityTypeEnum);
  const packageValues = Object.values(PackageTypeEnum);

  for (let i = 2; i <= 150; i++) {

    sheet.getCell(`C${i}`).dataValidation = {
      type: "list",
      allowBlank: true,
      formulae: [`"${qualityValues.join(",")}"`],
    };

    sheet.getCell(`F${i}`).dataValidation = {
      type: "list",
      allowBlank: true,
      formulae: [`"${packageValues.join(",")}"`],
    };
  }

  sheet.columns.forEach((col) => {
    col.width = 20;
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = "RM_Inward_Import_Format.xlsx";
  link.click();
};

  const  saveIndent = async () => {
     
    if (tableData.length === 0) {
      AlertMessages.getErrorMessage('Please add at least one item before submitting');
      return;
    }

   
    
    setSubmitBtnDisable(true)
    const formData = await form.getFieldsValue()
    console.log(formData,'form data')
    if (
      formData.rmInwardType === RMInwardTypeEnum.IMPORT &&
      (!formData.boeNum || !formData.boeNum.toString().trim() || !formData.boeDate)
    ) {
      AlertMessages.getErrorMessage(
        'BOE Number and BOE Date are mandatory for Import'
      );
      return;
    }
    let createdUserName
    let updatedUserName
    let indentId
    let plantId
    if (props.isUpdate) {
      updatedUserName = userName
      createdUserName = undefined
      indentId = props.indentData.indentId
      plantId = form.getFieldValue('plantId')
    } else {
      createdUserName = userName
      updatedUserName = undefined
      indentId = undefined
      plantId = form.getFieldValue('plantId') || undefined
    }
    let indentItems: IndentItemsModel[] = []
    tableData.forEach(element => {
      console.log(tableData);
      let indentItemId = undefined
      let brokerId = undefined
      let farmerCode = element.farmerCode
      if (formData.supplierType == SupplierTypeEnum.DEALER) {
        brokerId = element.broker
      }
      if (props.isUpdate) {
        indentItemId = element.indentItemId
        farmerCode = element.farmId
      }
      // console.log(formData.isVehicleRequired&&formData.farmType!=FarmTypeEnum.OWN,'iceeeeeeeeeee');
      
const indentItem = new IndentItemsModel(
  indentItemId,
  plantId,
  element.farmer,
  undefined, 
  element.product,
  undefined,
  element.expectedQty,
  undefined,
  undefined, undefined, undefined, undefined,
  undefined,
  undefined,
  userName,
  undefined, undefined, undefined,
  undefined, undefined,
  undefined, // rmRate
  undefined, // iceRate
  element.quality, 
  element.packageType,
   undefined,
  element.grossWeight,
  element.quantity,
  undefined,
  undefined,
  element.tareWeight

);
      indentItems.push(indentItem);
    });
    const indentModel = new IndentDetailsModel(plantId, formData.indentDate, formData.supplierType,
       undefined, undefined, undefined, undefined, undefined, undefined, indentItems, formData.indentBy, 
       createdUserName, updatedUserName, indentId, undefined, undefined, undefined, undefined, 
       undefined, undefined, undefined, undefined, formData.harvestType, undefined,
        formData.rmInwardType, formData.boeNum,formData.boeDate);
    console.log(indentModel)
    // indentModel.plantId = Number(plantId);
    if (props.isUpdate) {
      // Update RM Inward Details
      // indentModel.updatedUser = userName;
      indentModel.indentId = props.indentData.indentId;
      
      if (tableData.length > 0) {
        const firstFarmer = tableData[0].farmer;

        const isSame = tableData.every(
          item => item.farmer === firstFarmer
        );

        if (!isSame) {
          AlertMessages.getErrorMessage(
            "Vendor must be same for all Inward Items"
          );
          setSubmitBtnDisable(false);
          return; 
        }
      }
      
      indentService.updateIndent(indentModel).then(res => {
        if (res.status) {
          AlertMessages.getSuccessMessage('RM Inward Details Updated Successfully');
          onReset();
          props.closeDrawer();
        } else {
          if (res.intlCode) {
            // AlertMessages.getErrorMessage(res.internalMessage);
            setSubmitBtnDisable(false)
          } else {
            AlertMessages.getErrorMessage(res.internalMessage);
            setSubmitBtnDisable(false)
          }
        }
      }).catch(err => {
        AlertMessages.getErrorMessage(err.message);
      });
      // props.updateIndent(indentModel);
    } else {
      // Create Indent Details
      // indentModel.createdUser = userName;


      // indentModel.indentItems = indentItems;
      if (tableData.length > 0) {
        const firstFarmer = tableData[0].farmer;

        const isSame = tableData.every(
          item => item.farmer === firstFarmer
        );

        if (!isSame) {
          AlertMessages.getErrorMessage(
            "Vendor must be same for all Inward Items"
          );
          setSubmitBtnDisable(false);
          return; 
        }
      }
      indentService.createIndent(indentModel).then(res => {
        if (res.status) {
          AlertMessages.getSuccessMessage('RM Inward Created Successfully');
          history.push("/indent-view")
          onReset();
        } else {
          if (res.intlCode) {
            AlertMessages.getErrorMessage(res.internalMessage);
            setSubmitBtnDisable(false)
          } else {
            AlertMessages.getErrorMessage(res.internalMessage);
            setSubmitBtnDisable(false)
          }
        }
      }).catch(err => {
        AlertMessages.getErrorMessage(err.message);
      });
    }
  };

  const onReset = () => {
form.resetFields([
  'farmer',
  'product',
  'quality',
  'expectedQty',
  'grossWeight',
  'packageType'
]);
    setType('');
    setIsFixed(false);
  }

  const getAllIndentEmployees = () => {
    empService.getAllActiveEmployees().then(res => {
      if (res.status) {
        const employeesWithFullName = res.data.map(employee => ({
          ...employee,
          fullName: `${employee.employeeName}.${employee.employeeLastName}`}))
          setIndentEmployees(employeesWithFullName)
      } else {
        if (res.intlCode) {
          setIndentEmployees([]);
          AlertMessages.getErrorMessage('No Employees Data Found');
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
      setIndentEmployees([]);
    });
  }

  const setSelectedData = () => {
    form.validateFields().then(res => {
      console.log(res)
      let values = form.getFieldsValue();
      console.log(values)
      console.log(btnChange)

      if (Number(values.tareWeight) > Number(values.grossWeight)) {
    AlertMessages.getErrorMessage(
        "Tare Weight cannot be greater than Gross Weight"
    );
    return;
}

      setShowTable(true);
      if (btnChange) {
const farmerdata = farmers.find(
  item => item.supplierId == values.farmer?.value
);
        console.log(farmerdata)

        const productsData = products.find(item => item.productId == values.product);
        const farmsData = farmerCodes.find(item => item.supplierId == values.farmerCode);
        let dealerName = undefined;
        let brokersData;
        if (values.supplierType == SupplierTypeEnum.DEALER) {
          brokersData = brokers.find(item => item.supplierId == values.broker);
          dealerName = brokersData.supplierName
        }
        console.log(farmsData)
        let indentItemId = undefined;

        let dyntableData = [...tableData];
        if (props.isUpdate) {
          indentItemId = dyntableData[indexVal].indentItemId;
        }
let updatedobject = {
  farmer: values.farmer?.value,
  farmerName: farmerdata?.supplierCode  || '',

  product: values.product,
  productName: productsData?.productName || '',

  quality: values.quality,
  expectedQty: values.expectedQty,
  grossWeight: values.grossWeight,
  tareWeight: values.tareWeight,
  packageType: values.packageType,
  
  indentItemId: indentItemId,

}
        console.log(updatedobject);
        dyntableData[indexVal] = updatedobject
        setTableData(dyntableData);
        setBtnChange(false);
      } else {
        setSubmitBtnDisable(false)
        let brokerId = undefined;
        let brokerData;
        console.log(values)
        console.log(brokers)
        let dealerName = undefined;
        if (values.supplierType == SupplierTypeEnum.DEALER) {
          brokerId = values.broker;
          brokerData = brokers.find(item => item.supplierId == brokerId);
          dealerName = brokerData.supplierName
        }
        console.log(brokerData)
const farmerdata = farmers.find(
  item => item.supplierId == values.farmer?.value
);
        console.log(farmerdata)

        const productsData = products.find(item => item.productId == values.product);
        const farmsData = farmerCodes.find(item => item.supplierId == values.farmerCode);

        console.log(values)
        console.log(farmerdata)
let object = {
  farmer: values.farmer?.value,
  farmerName: farmerdata?.supplierCode  || '',

  product: values.product,
  productName: productsData?.productName || '',

  quality: values.quality,   
  expectedQty: values.expectedQty,    
  grossWeight: values.grossWeight,   
  tareWeight: values.tareWeight,    
  packageType: values.packageType,           
  indentItemId: undefined
}
        console.log(object)
        let dynTableData = [...tableData, object]
        setTableData(dynTableData);
        setBtnChange(false);
      }
form.setFieldsValue({
  quality: null,
  expectedQty: null,
  tareWeight: null,
  grossWeight: null,
 
})    })
  }

  const deleteData = (index) => {
    tableData.splice(index, 1);
    setTableData([...tableData]);
    if (tableData.length == 0) {
      setShowTable(false)
    }
  }

  const setEditForm = (rowData, index) => {
    console.log(rowData)
    setBtnChange(true);
    let farmCode = rowData.farmerCode;
    if (props.isUpdate) {
      farmCode = rowData.farmId
      if (form.getFieldValue('supplierType') == SupplierTypeEnum.DEALER) {
        brokerChange(rowData.broker)
        // farmerChange(rowData.farmer);
      } else {
        // farmerChange(rowData.farmer);
      }
    }
    console.log('test')
form.setFieldsValue({
  farmer: {
    value: rowData.farmer,
    label: rowData.farmerName
  },
  product: rowData.product,
  quality: rowData.quality,
  expectedQty: rowData.expectedQty,
  grossWeight: rowData.grossWeight,
  packageType: rowData.packageType,
  tareWeight: rowData.tareWeight,
});
    console.log('test')

    // if(props.isUpdate){
    //   form.setFieldsValue({farmerCode:rowData.farmName})
    // }
    setIndexVal(index);
  }

const columns = [
    {
      title: 'Dealer',
      dataIndex: 'dealerName',
      key: 'dealerName',
      render: (text, data, index) => {

        return <span>{text}</span>
      }
    },
    {
      title: 'Vendor',
      dataIndex: 'farmerName',
      render: (text, data, index) => {

        return <span>{text}</span>
      }
    },
    
    {
      title: 'Variant',
      dataIndex: 'productName',
      render: (text, data, index) => {

        return <span>{text}</span>
      }
    },
    {
      title: 'Quality',
      dataIndex: 'quality',
      render: (text, data, index) => {

        return <span>{text}</span>
      }
    },
    // ...(form.getFieldValue('rmInwardType') === RMInwardTypeEnum.IMPORT
    // ? [
      {
          title: 'Gross Weight',
          dataIndex: 'grossWeight',
        },
    //     ]
    // : []),
    {
    title: "Tare Weight",
    dataIndex: "tareWeight",
},
    {
      title: 'Net Quantity',
      dataIndex: 'expectedQty',
      render: (text, data, index) => {

        return <span>{text}</span>
      }
    },
     
    {
    title: 'Package Type',
    dataIndex: 'packageType',       
  },
  // ...(form.getFieldValue('rmInwardType') === RMInwardTypeEnum.IMPORT
  //   ? [
      
  //       {
  //         title: 'BOE Number',
  //         dataIndex: 'boeNum',
  //       },
  //       {
  //         title: 'BOE Date',
  //         dataIndex: 'boeDate',
  //         render: (text) =>
  //           text ? moment(text).format('YYYY-MM-DD') : '',
  //       },
  //     ]
  //   : []),
  
   
    {
      title: 'Action',
      dataIndex: 'action',
      // width: '20%',
      render: (text, rowData: any, index) => (
        <span>
          <Tooltip placement="top" title='edit'>
            <EditOutlined className={'editSamplTypeIcon'} type="edit"
              onClick={() => {
                if (rowData) {
                  setEditForm(rowData, index);
                }
              }}
              style={{ color: '#1890ff', fontSize: '14px' }}
            />
          </Tooltip>
          {
            !(props.isUpdate) ?
              <><Divider type="vertical" />
                <Tooltip placement="top" title='delete'>
                  <MinusCircleOutlined onClick={() => {
                    if (rowData) {
                      deleteData(index)
                      // openFormWithData(rowData);
                    }
                  }}
                    style={{ color: '#1890ff', fontSize: '14px' }} />
                </Tooltip>
              </> : <></>
          }
        </span>)
    }

  ]

  const clearDependentData = () => {
    // alert();
    form.setFieldsValue({ isVehicleRequired: '' })
    form.setFieldsValue({ harvestType: '' })
    form.setFieldsValue({ vehicleType:'' })

  }



  return (
    <Card
      title={<span style={{ color: 'white' }}>RM Inward</span>}
      style={{ textAlign: 'center' }}
      headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
      extra={props.isUpdate == true ? "" : <Link to='/indent-view' ><span style={{ color: 'white' }} ><Button className='panel_button' > View </Button> </span>  </Link>}>
      <Form
        layout="vertical"
        form={form}
        name="control-hooks"
        // initialValues={props.indentData}
        // onFinish={saveIndent}
        autoComplete={"off"}
      // key= {Date.now()}
      >
        <Row gutter={24}>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
            <Form.Item name="indentDate" label="RM Inward Date" rules={[{ required: true, message: 'RM Inward Date is required' }]} initialValue={moment()}>
              <DatePicker onChange={() => { }} disabledDate={(current) => {
        return current && current > moment().endOf('day');
      }} style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
            <Form.Item name="indentBy" label="Inward Supervisor" rules={[{ required: true, message: 'Inward Supervisor is required' }]}>
              <Select
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                placeholder="Select Inward Supervisor"
                allowClear={true}
              >
                {indentEmployees.map((emp) => {
                  return <Option value={emp.employeeId}>{emp.fullName}</Option>
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
            <Form.Item name="rmInwardType" label="RM Inward Type" rules={[{ required: true, message: 'RM Inward Type is required' }]}>
              <Select placeholder="Select RM Inward Type" onChange={(value) => setRmType(value)}>
                {Object.keys(RMInwardTypeEnum).map((type) => (
                  <Option value={RMInwardTypeEnum[type]}>
                    {RMInwardTypeEnum[type]}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col >
            <Form.Item name="supplierType" label="Supplier Type" initialValue={SupplierTypeEnum.FARMER} rules={[{ required: true, message: 'Supplier Type is required' }]} hidden>
              <Select
                showSearch
                placeholder="Select Supplier Type"            
                allowClear={true}
                onClear={clearDependentData}
              >
                {/* <Option value="Agent">Agent</Option> */}
                <Option value="Farmer">Farmer</Option>
                {/* <Option value="Dealer">Dealer</Option> */}
                {/* {Object.keys(SupplierTypeEnum).map((type)=>{
                  return <Option value={SupplierTypeEnum[type]}>{SupplierTypeEnum[type]}</Option>
                })} */}
              </Select>
            </Form.Item>
          </Col>
          
          {/* <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
            <Form.Item name="harvestingTime" label="Harvesting Time" initialValue={HarvestingTime.MORNING} rules={[{ required: true, message: 'Harvesting Time is required' }]}>
              <Select
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                placeholder="Select Harvesting Time"
                allowClear={true}
              >
                {Object.keys(HarvestingTime).map((hTime) => {
                  return <Option value={HarvestingTime[hTime]}>{HarvestingTime[hTime]}</Option>
                })}
              </Select>
            </Form.Item>
          </Col> */}
          {/* <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
            <Form.Item name="assignLead1" label="Greader 1" 
             rules={[{ required: isHarvest, message: 'Greader 1 is required' }]}
            >
              <Select
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                placeholder="Select Greader 1"
                onChange={(value) => {
                  setAssignLead1(Number(value))
                }}
                allowClear={true}
              >
                <Option value={null}>Select Greader 1</Option>
                {employees.map((emp) => {
                  return (emp.employeeId != assignlead2) ? <Option value={emp.employeeId}>{emp.employeeName}</Option> : null
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
            <Form.Item name="assignLead2" label="Greader 2" rules={[{ required: false, message: 'Greader 2 is required' }]}>
              <Select
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                placeholder="Select Greader 2"
                allowClear={true}
                onChange={(value) => {
                  setAssignLead2(Number(value))
                }}
              >
                <Option value={null}>Select Greader 2</Option>
                {employees.map((emp) => {
                  return (emp.employeeId != assignlead1) ? <Option value={emp.employeeId}>{emp.employeeName}</Option> : null
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
            <Form.Item name="indentBy" label="Indent By" rules={[{ required: true, message: 'Indent By is required' }]}>
              <Select
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                placeholder="Select Indent By"
                allowClear={true}
              >
                <Option value={null}>Select Indent By</Option>
                {indentEmployees.map((emp) => {
                  return <Option value={emp.employeeId}>{emp.fullName}</Option>
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
            <Form.Item name="isVehicleRequired" label="Is Vehicle Required" rules={[{ required: true, message: 'Is Vehicle Required is required' }]}>
              <Select
                placeholder="Select Is Vehicle Required"
                allowClear
                onChange={onVehicleRequiredChange}
              >
                <Option value={1}>YES</Option>
                <Option value={0}>NO</Option>

              </Select>
            </Form.Item>
          </Col> 
          commented as these fields are not required as per new changes in requirement
          */}


          {/* <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}> */}
          <Col>
            <Form.Item name="harvestType" label="Harvest Type" hidden initialValue="Re Weighment" rules={[{ required: true, message: 'Harvest Type is required' }]}>
              <Select
                placeholder="Select Harvest Type"
                allowClear
                
              >
                <Option value="Re Weighment">Re Weighment</Option>
                {/* <Option value="Live Harvest">Live Harvest</Option> */}

              </Select>
            </Form.Item>
          </Col>

          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }}>
            <Form.Item name="plantId" label="Plant" initialValue={1} rules={[{ required: true, message: 'Missing Unit' }]} >
              <Select
                placeholder="Select Plant"
                allowClear
                
              // disabled={userName != 'rmmanager'}
              >
                {/* <Option value={null || 0}>Select Plant</Option> */}
                {factoriesData.map(dropData => {
                  return <Option value={dropData.plantId}>{dropData.plantCode}</Option>
                })}

              </Select>
            </Form.Item>
     
          </Col>
                     {rmType === RMInwardTypeEnum.IMPORT && (
  <>
    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
            <Form.Item name="boeDate" label="BOE Date" rules={[{ required: true, message: 'BOE Date is required' }]}>
              <DatePicker  style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
            <Form.Item name="boeNum" label="BOE Number" rules={[{ required: true, message: 'BOE Number is required' }]}>
              <Input />
            </Form.Item>
          </Col>
  </>
)}
          {/* {form.getFieldValue('isVehicleRequired') === 1?  */}

          
          {/* :''} */}
          {/* {props.isUpdate?
          <Col span={6}>
          <Form.Item name="subPlantId" label="Sub Plant"
          //  rules={[{ required: true,message:'Assignlead 2 is required' }]}
          >
            <Select
              showSearch
              optionFilterProp="children"
                filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              placeholder="Select Sub Plant"
              allowClear = {true}
            >
              <Option value={null}>Select Sub Plant</Option>
              {employees.map((emp)=>{
                return <Option value={emp.employeeId}>{emp.employeeName}</Option>
              })}
            </Select>
          </Form.Item>
        </Col>
          :''} */}
        </Row>
        {(rmType !== RMInwardTypeEnum.IMPORT || props.isUpdate) && (
        <Card title={<span style={{ color: 'white' }}>RM Inward Items</span>} style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }}>
          <Row gutter={24}>
            
              <Col xs={{ span: 26 }} sm={{ span: 26 }} md={{ span: 8 }} lg={{ span: 8 }} xl={{ span: 6 }}>
              <Form.Item
                name="farmer"
                label={type === SupplierTypeEnum.AGENT ? 'Agent' : 'Vendor'}
                rules={[{
                  required: type !== SupplierTypeEnum.DEALER,
                  message: type === SupplierTypeEnum.AGENT ? 'Agent required' : 'Vendor required'
                }]}
              >
                <Select
                  showSearch
                  labelInValue
                  optionFilterProp="label"
                  filterOption={(input, option) =>
                    String(option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                  }
                  placeholder={type === SupplierTypeEnum.AGENT ? 'Select Agent' : 'Select Vendor'}
                  allowClear
                >
                 
                  {farmers.map((farmer) => {
                    const isRejected = farmer.antibioticsIdentifiedFarmer === "REJECTED";
                    // const label = `${farmer.supplierName} (${farmer.supplierCode})${isRejected ? ' (Rejected)' : ''}`;
                    const label = `${farmer.supplierCode}`;

                    return (
                      <Option
                        key={farmer.supplierId}
                        value={farmer.supplierId}
                        disabled={isRejected}
                        label={label}
                        style={isRejected ? { backgroundColor: '#ffcccc' } : {}}
                      >
                        {label}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>

                  
            <Col xs={{ span: 12 }} sm={{ span: 12 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 1 }} style={{marginRight:'40px'}}>
              <Form.Item>
                <Link to='/suppliers-form'><Button style={{ marginTop: 30 }}> Add </Button></Link>
              </Form.Item>
            </Col>
                  
            {/* <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
              <Form.Item name="farmerCode" label="Farmer Code" rules={[{ required: false, message: 'Farmer Code is required' }]}>
                <Select
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  placeholder="Select Farmer Code"
                  onChange={farmerCodeChange}
                  allowClear={true}
                >
                  <Option value={null}>Select Farmer Code</Option>
                  {farmerCodes.map((farm) => {
                    return <Option value={farm.supplierId}>{farm.supplierName + '(' + farm.supplierCode + ')'}</Option>
                  })}
                </Select>
              </Form.Item>
            </Col> */}
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
              <Form.Item name="product" label="Variant"  rules={[{ required: true, message: 'Variant is required' }]}>
                <Select
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  placeholder="Select Variant"
                  allowClear={true}
                >
                  <Option value={null}>Select Variant</Option>
                  {products.map((product) => {
                    return <Option value={product.productId}>{product.productName}</Option>
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
              <Form.Item
                name="quality"
                label="Quality"
                rules={[{ required: true, message: 'Quality is required' }]}
              >
                <Select placeholder="Select Quality" allowClear>
                  {Object.values(QualityTypeEnum).map((quality) => (
                    <Option key={quality} value={quality}>
                      {quality}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            
            {/* {rmType === RMInwardTypeEnum.IMPORT && ( */}
              <>
                <Col span={6}>
                  <Form.Item
                    name="grossWeight"
                    label="Gross Weight"
                    rules={[{ required: true, message: "Gross Weight is required" }]}
                  >
                    <InputNumber
                      min={0}
                      style={{ width: "100%" }}
                      onChange={(value) => {
                        const tare = form.getFieldValue("tareWeight") || 0;
                        form.setFieldsValue({
                          expectedQty: Number(value || 0) - Number(tare),
                        });
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
  <Form.Item
    name="tareWeight"
    label="Tare Weight"
    rules={[{ required: true, message: "Tare Weight is required" }]}
  >
    <InputNumber
      min={0}
      style={{ width: "100%" }}
      onChange={(value) => {
        const gross = form.getFieldValue("grossWeight") || 0;
        form.setFieldsValue({
          expectedQty: Number(gross) - Number(value || 0),
        });
      }}
    />
  </Form.Item>
</Col>
              </>
            {/* )} */}
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
              <Form.Item name="expectedQty" label="Net Quantity" rules={[{ required: true, message: 'Net Quantity is required' }
                ]}>
                <InputNumber min={0} style={{ width: '100%' }} disabled/>
              </Form.Item>
            </Col>
            
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
              <Form.Item name="packageType" label="Package Type">
                <Select placeholder="Select Package Type" allowClear>
                  {Object.values(PackageTypeEnum).map((type) => (
                    <Option key={type} value={type}>
                      {type}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 3 }} lg={{ span: 3 }} xl={{ span: 3 }}>
              <Form.Item style={{ marginTop: '29px' }}>

                {/* <br /> */}
                <Button type="primary" onClick={setSelectedData}>
                  {btnChange ? 'Update' : 'Add'}
                </Button>
              </Form.Item>
            </Col>
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 2 }} lg={{ span: 2 }} xl={{ span: 2 }}>
              <Form.Item style={{ marginTop: '29px' }}>
                <Button style={{ backgroundColor: "#f19c9b", color: "white" }}
                  onClick={onReset}
                >
                  Reset
                </Button>
              </Form.Item>
            </Col>
          </Row>
          <br />
          {
            showTable ?
              <Table dataSource={tableData} columns={(form.getFieldValue('supplierType') != SupplierTypeEnum.DEALER) ? columns.filter(col => (col.dataIndex != 'dealerName')) : columns} pagination={false} 
              summary={(pageData) => {
    const totalQty = pageData.reduce(
      (sum, row) => sum + Number(row.expectedQty || 0),
      0
    );
    const totalGrossWeight = pageData.reduce(
  (sum, row) => sum + Number(row.grossWeight || 0),
  0
);
const totalTareWeight = pageData.reduce(
  (sum, row) => sum + Number(row.tareWeight || 0),
  0
);
    const isDealer = form.getFieldValue('supplierType') == SupplierTypeEnum.DEALER;

     return (
    <Table.Summary.Row>
<Table.Summary.Cell index={0} colSpan={isDealer ? 4 : 3}>
          <div style={{ textAlign: 'left' }}>
          <strong>Total</strong>
        </div>
      </Table.Summary.Cell>
      <Table.Summary.Cell index={1}>
  <div style={{ textAlign: 'left' }}>
    <strong>{totalGrossWeight.toFixed(2)}</strong>
  </div>
</Table.Summary.Cell>

<Table.Summary.Cell index={2}>
  <div style={{ textAlign: 'left' }}>
    <strong>{totalTareWeight.toFixed(2)}</strong>
  </div>
</Table.Summary.Cell>

<Table.Summary.Cell index={3}>
  <div style={{ textAlign: 'left' }}>
    <strong>{totalQty.toFixed(2)}</strong>
  </div>
</Table.Summary.Cell>
<Table.Summary.Cell index={4} />

<Table.Summary.Cell index={5} />
    </Table.Summary.Row>
  );
  }}
              /> : <></>
          }
          <Row>
            <Col span={24} style={{ textAlign: 'right' }}>
              <Button 
              // disabled={submitBtnDisable} 
              type="primary" onClick={saveIndent}>
                Submit
              </Button>
            </Col>
          </Row>
        </Card>
        )}

        {rmType === RMInwardTypeEnum.IMPORT && !props.isUpdate && (
  <Card
    title={<span style={{ color: 'white' }}>Import Upload</span>}
    style={{ textAlign: 'center' }}
    headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
    
  >
    <Row gutter={24} align="middle">
      
              <Col xs={{ span: 26 }} sm={{ span: 26 }} md={{ span: 8 }} lg={{ span: 8 }} xl={{ span: 6 }}>
              <Form.Item
                name="farmer"
                label={type === SupplierTypeEnum.AGENT ? 'Agent' : 'Vendor'}
                rules={[{
                  required: type !== SupplierTypeEnum.DEALER,
                  message: type === SupplierTypeEnum.AGENT ? 'Agent required' : 'Vendor required'
                }]}
              >
                <Select
                  showSearch
                  labelInValue
                  optionFilterProp="label"
                  filterOption={(input, option) =>
                    String(option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                  }
                  placeholder={type === SupplierTypeEnum.AGENT ? 'Select Agent' : 'Select Vendor'}
                  allowClear
                >
                 
                  {farmers.map((farmer) => {
                    const isRejected = farmer.antibioticsIdentifiedFarmer === "REJECTED";
                    const label = `${farmer.supplierCode}`;
                    return (
                      <Option
                        key={farmer.supplierId}
                        value={farmer.supplierId}
                        disabled={isRejected}
                        label={label}
                        style={isRejected ? { backgroundColor: '#ffcccc' } : {}}
                      >
                        {label}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
              
            
        
      <Col span={8}>
        <Form.Item label="Upload File">
          <Input
            type="file"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            onChange={handleFileChange}
          />
          <div style={{ color: 'blue', fontSize: '12px' }}>
            Only csv & excel files are allowed
          </div>
        </Form.Item>
      </Col>
<Col span={8} style={{ textAlign: 'right' }}>
        <Button type="primary" onClick={downloadSample}>
          Download Sample Format
        </Button>
      </Col>
      
    </Row>


    <Row>
      <Col span={24} style={{ textAlign: 'right' }}>
          <Button type="primary" disabled={!file} onClick={handleImportSubmit}>
            Submit
        </Button>
      </Col>
    </Row>
  </Card>
)}
      </Form>
    </Card>
  );
}

export default IndentForm;
